import React from 'react';

const _interest_area_group = () => {
	return <div></div>;
};

export default _interest_area_group;
